import { useEffect, useRef, useState } from 'react'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'
import { EVENTS_GAME, once } from '../../../../b.providers/EventsProvider/EventsProvider'
import { SEL_BATTLE_STATE } from '../../../../c.managers/LevelManager/selectors'
import { BATTLE_STATES } from '../../../../c.managers/LevelManager/store.d'
import { Battle } from '../../../BattleController'

const BATTLE_TIMEOUT = 2 * 1000 * 60 +  38 * 1000 // 2:38
const BattleTimer = () => {
  const tId = useRef<NodeJS.Timeout>()
  const [time, setTime] = useState<number>(BATTLE_TIMEOUT)
  const [start, setStart] = useState<boolean>(false)
  const battleState = useSceneStore(SEL_BATTLE_STATE)

  const updateTime = () => {
    setTime(t => Math.max(t - 1000, 0))
  }

  useEffect(() => {
    if (time === 0) {
      setStart(false)
      Battle.finishBattle()
    }
  }, [time])

  useEffect(() => {
    if (start) {
      tId.current = setInterval(updateTime, 1000)
    }
    return () => {
      clearInterval(tId.current)
    }
  }, [start])

  useEffect(() => {
    if (battleState === BATTLE_STATES.ONGOING) {
      setStart(true)
    } else if(battleState === BATTLE_STATES.ENDED) {
      setStart(false)
    }
  }, [battleState])

  return (
    <div
      style={{
        display: 'flex',
        flexBasis: '100%',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
      }}
      >
      <span style={{
        color: '#ffffff',
        fontSize: '3em',
        fontFamily: 'HellghostRough',
        textShadow: `0px 1px 0 #430064, 1px 0px 0 #430064, -1px 0px 0 #430064, 0px -1px 0 #430064,
        0px 2px 0 #430064, 2px 0px 0 #430064, -2px 0px 0 #430064, 0px -2px 0 #430064,
        0px 3px 0 #430064, 3px 0px 0 #430064, -3px 0px 0 #430064, 0px -3px 0 #430064,
        0px 4px 0 #430064, 4px 0px 0 #430064, -4px 0px 0 #430064, 0px -4px 0 #430064`,
        marginRight: '10px',
      }}>{secondsToTime(time / 1000)}</span>
    </div>
  )
}
export default BattleTimer

function secondsToTime(e: number) {
  const m = Math.floor((e % 3600) / 60)
      .toString()
      .padStart(2, '0'),
    s = Math.floor(e % 60)
      .toString()
      .padStart(2, '0')

  return m + ':' + s
  //return `${h}:${m}:${s}`;
}
